import { Component, OnInit } from '@angular/core';
import { ServerService } from "../server.service";
import Swal from 'sweetalert2'
import { usuario } from './../models/user';
import { FormControl, FormGroup, Validators } from "@angular/forms";

import {Router} from '@angular/router';
@Component({
  selector: 'app-registro-profesores',
  templateUrl: './registro-profesores.component.html',
  styleUrls: ['./registro-profesores.component.css']
})
export class RegistroProfesoresComponent implements OnInit {
  credentialsInvalid: boolean = false; // credenciales validas
  regex = new RegExp('^(?=.*[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,15}$');
  messageError: string = '';
  opcion:number =1;

  active = 1;


  myForm = new FormGroup({


    carnet: new FormControl("", [
      Validators.required,


    ]),
    userName: new FormControl("", [
      Validators.required,
      Validators.minLength(4), //min de tamañao para usuario

    ]),
    userLastName: new FormControl("", [
      Validators.required,
      Validators.minLength(4)

    ]),

    userPass: new FormControl("", [
      Validators.required,
      Validators.minLength(7),
      Validators.maxLength(15),
      Validators.pattern('^(?=.*[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,15}$')

    ]),


  });
  constructor(private server: ServerService,private router:Router) {

  }

  ngOnInit(): void {
  }

  onSubmit(): void {

    const user = this.myForm.value;


    if( user.carnet === '' ||  user.userName === '' || user.userLastName === '' || user.userPass === ''
      ){

        this.credentialsInvalid = true;

         this.messageError = 'Faltan campos a ingresar';
         setTimeout(() => {this.credentialsInvalid = false;},3500);
         return;

    }
    const usuario: usuario = {
      carnet:            user.carnet,
      nombre:            user.userName,
      apellido:          user.userLastName,
      correo:            user.userEmail,
      password:          user.userPass,
      passwordconfir:    user.userPassConfirm,
      estado:            1, //habilitado o deshabilitado
      idRol:             2,//rol de Docentes
      banderareseteo:    1,
    }
   if(this.myForm.valid){
      this.server.postRegistro(usuario).subscribe((data: {msg:string})=> {

        if(data["status"]  === 'error'){
           this.credentialsInvalid = true;
            this.messageError = 'El carnet ya existe';
          setTimeout(() => {this.credentialsInvalid = false;},3500);
          return;

        }
         this.opensweetalert();
        setTimeout(() => location.href='/registroprofesores', 4000);
       }
      , error => {
        this.credentialsInvalid = true;
        this.messageError = 'Error en la conexión';
        setTimeout(() => {this.credentialsInvalid = false;},3500);
      })
    }
  }

opensweetalert():void{
  Swal.fire({
    position: 'top',
    icon: 'success',
    title: 'Docente registrado con exito',
    showConfirmButton: false,
    timer: 4000
  })
}

logout():void {
  localStorage.removeItem("rol")
  this.router.navigateByUrl('/login');
}

//gets para obtener en interfaz y hacer validaciones
get carnet() {return this.myForm.get('carnet');}
get userName() {return this.myForm.get('userName');}
get userLastName() {return this.myForm.get('userLastName');}
get userPass() {return this.myForm.get('userPass');}

}
